import { FC, RefObject, createRef, useEffect, useRef, useState } from 'react';
import { TransactionType } from 'global/Securities/types/transaction';
import produce from 'immer';
import {
  BackgroundHighlight,
  Container,
  SwitchButton,
  SwitchWrapper,
} from './styled';

interface TransactionTypeSwitchProps {
  onChange?(transactionType: TransactionType): void;
  defaultValue?: TransactionType;
  disabled?: boolean;
}

interface SwitchButtonRefs {
  [TransactionType.Buy]?: RefObject<HTMLButtonElement>;
  [TransactionType.Sell]?: RefObject<HTMLButtonElement>;
}

const TransactionTypeSwitch: FC<TransactionTypeSwitchProps> = ({
  defaultValue = TransactionType.Buy,
  onChange = () => {},
  disabled = false,
}) => {
  const switchRefs = useRef<SwitchButtonRefs>({
    [TransactionType.Buy]: createRef(),
    [TransactionType.Sell]: createRef(),
  });

  const [activeTransactionType, setActiveTransactionType] =
    useState<TransactionType>(defaultValue);
  const [highlightConfig, setHighlightConfig] = useState({
    width: 0,
    left: 0,
  });

  const handleSetHighlightConfig = (transactionType: TransactionType) => {
    setHighlightConfig(
      produce(highlightConfig, (draft) => {
        draft.width =
          switchRefs.current[transactionType].current?.offsetWidth || 0;
        draft.left =
          switchRefs.current[transactionType].current?.offsetLeft || 0;
      }),
    );
  };

  const handleSwitchTransactionType =
    (transactionType: TransactionType) => () => {
      setActiveTransactionType(transactionType);
      onChange(transactionType);
    };

  useEffect(() => {
    handleSetHighlightConfig(activeTransactionType);
  }, [activeTransactionType]);

  return (
    <Container>
      <BackgroundHighlight
        style={{
          ...highlightConfig,
        }}
      />
      <SwitchWrapper>
        <SwitchButton
          ref={switchRefs.current[TransactionType.Buy]}
          className="buy"
          onClick={handleSwitchTransactionType(TransactionType.Buy)}
          disabled={disabled}
        >
          Buy
        </SwitchButton>
        <SwitchButton
          ref={switchRefs.current[TransactionType.Sell]}
          className="sell"
          onClick={handleSwitchTransactionType(TransactionType.Sell)}
          disabled={disabled}
        >
          Sell
        </SwitchButton>
      </SwitchWrapper>
    </Container>
  );
};

export default TransactionTypeSwitch;
